$(document).ready(function(){
  if ($('body.template-collection').length) {
    localStorage.setItem("currentPage",0);
    $(window).scroll(function(){
      if($('.ProductListWrapper-Infinite-Pagination').length > 0){
        var windowTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var heightList = $('.ProductListWrapper-Infinite-Pagination').offset().top;
        var bottomPage = ($('#shopify-section-yotpo-instagram-feed').offset()); // delete .offset().top
        if(windowTop > (heightList - windowHeight - 200) && windowTop < (bottomPage - windowHeight) ){
          if(!$('.ajax-bkg').hasClass('show')) {
            $('.ProductListWrapper-Infinite-Pagination a').trigger('click');
          }
        }
      }
    });
    $('.ProductListWrapper-Infinite-Pagination a').on('click', function(e){
      e.preventDefault();
      var this72 = $(this);
      if(localStorage.getItem("currentPage") == 0) {
        var dataCurrent = $(this).data('current');
      } else {
        var dataCurrent = localStorage.getItem("currentPage");
      }
      
      var currentPage = $(this).attr('href');
      var maxPage = $(this).data('maxpage');
      var number =  parseInt(dataCurrent) + 1;
      localStorage.setItem("currentPage",number);
      
      if(parseInt(dataCurrent) < parseInt(maxPage)) {
        var dataCollection = $(this).attr('href');
        $('.ajax-bkg').addClass('show');
        $.ajax({
          url:  dataCollection,
          type: 'GET'
        })
        .done(function(data) {
          //$('.ProductListWrapper-Infinite').html(data);
          var $data = $(data);
          var productItems = $data.find('.ProductItem');
          $('.ProductList.ProductList--grid').append($data);
          $('.ajax-bkg').removeClass('show');
          var nextPage = currentPage.substring(0,currentPage.indexOf('?')) + '?page=' + (number + 1) + '&view=ajaxinfinite';
          this72.attr('href',nextPage);
          this72.attr('data-current',number);
          loadBundleControls(productItems);
          
        })
        .fail(function(data) {})
        .always(function(data) {});
      }
    });
  }
});

// $(document).on('collection_loadmore', function (data) {
//   var productItems = data.find('.ProductItem');
//   loadBundleControls(productItems);
// })

function initPage(){
  loadBundleControls();
  getCartContents();
  showBundleSavings();
  loadBundleButton();
  clickAddBundle();

}

function loadBundleControls(productItems = false){
  if (!productItems) {
    productItems = $('.ProductItem');
  }
  $.map(productItems, function(product) {
    var productItem = $(product);
    let loaded=productItem.attr('loaded');
    if(loaded===undefined){
      productItem.find('.productButton').removeClass('normalProduct');
      productItem.attr('loaded','true');
      productItem.attr('data-qty',0);
      productItem.find('form').remove();
    
      loadProductButton(productItem,0);
      clickProduct(productItem);
    }
    
  });
}

function showBundleSavings(){
  
 $('.ProductList .ProductItem').each(function(){ 
    var original_price = $(this).find('.ProductItem__PriceList').attr('data-price')
    
    let orignal_actual_price=parseFloat(original_price.replace(/,/g, ''));
    var new_price = orignal_actual_price - ((orignal_actual_price * 10) / 100);
    var rounded_price = Math.round((new_price + Number.EPSILON) * 100) / 100;
    var price = $(this).find('.money');
    $(this).find('.ProductItem__PriceList').html('<span class="ProductItem__Price Price" data-money-convertible=""><span class="money" data-bundle-price="'+ rounded_price +'">$' + rounded_price + ' </span><span class="money strikeout">$'+original_price+'</span><span> Save 10%</span></span>')
    $(this).attr('data-bundle-price', rounded_price);
//      if($(this).find('.ProductItem__Price').hasClass('Price--compareAt') == false){
//       $(price).addClass('strikeout');
//       $(price).after('<span> Save 10%</span>');
//       $(price).before('<span class="money">$' + rounded_price + ' </span>');
//       $(price).attr('data-bundle-price', rounded_price);
//      }
 })
//   $.map($('.ProductItem'), function(product) {

//     var price =  $(product).find('.money');
//     var original_price = parseFloat(price.text().replace('$',''));
//     var new_price = original_price - (original_price * 0.1);
//     var rounded_price = Math.round((new_price + Number.EPSILON) * 100) / 100;

//     price.addClass('strikeout');
//     $(price).after('<span> Save 10%</span>');
//     $(price).before('<span class="money">$' + rounded_price + ' </span>');
//     $(product).attr('data-bundle-price', rounded_price);
//   })
}

function clickProduct(product){
  product.find('.addQty').on( "click", function(e) {
    console.log('Clicked Add');
    var product = $(e.target).closest('.ProductItem');
    var qty = addQty(product.attr('data-qty'));
    product.attr('data-qty', qty);
    loadProductButton(product, qty);
  });
  product.find('.removeQty').on( "click", function(e) {
    console.log('Remove Clicked');
    var product = $(e.target).closest('.ProductItem');
    var qty = removeQty(product.attr('data-qty'));
    product.attr('data-qty', qty);
    loadProductButton(product, qty);
  });
  $('.clearQty').unbind("click").on( "click", function(e) {
    console.log('Remove All');
    var product = $(e.target).closest('.ProductItem');
    var qty = removeAll();
    product.attr('data-qty', qty);
    loadProductButton(product, qty);
  });
  productsCount();
}

function addQty(qty){
  console.log('Add 1',);
  return parseInt(qty,10) + 1;
}

function removeQty(qty){
  console.log('Remove 1',);
  return parseInt(qty,10) - 1;
}

function removeAll(){
  console.log('Remove All',);
  return 0;
}

function loadProductButton(productItem, qtyAdded){
  var vid = productItem.data('variant');
  var controlText = qtyAdded == 0 ? 'Add Product' : '+';
  var lid = productItem.data('lid');
  var lindex = productItem.data('lindex');
  var addQtyControls = '<span class=\"checked clearQty\"><svg class=\"Icon Icon--removeAll\" role=\"presentation\" viewBox=\"0 0 16 14\"><path d=\"M15 0L1 14m14 0L1 0\" stroke=\"currentColor\" fill="none\" fill-rule=\"evenodd\"></path></svg></span><span class=\"removeQty\">-</span><span data-lindex=\"' + lindex + '\" data-lid=\"' + lid + '\" class=\"qtyCount\" data-variant=\"' + vid + '\" data-count=\"' + qtyAdded + '\">&nbsp;<strong>' + qtyAdded + '</strong>&nbsp;</span><span class=\"addQty\">' + controlText + '</span>';
  productItem.find('button').html(addQtyControls);
  if(qtyAdded >= 1){
    selectProduct(productItem);
    clickProduct(productItem);
  } else { 
    unSelectProduct(productItem);
    clickProduct(productItem);
  }
  console.log('loadProductButton');
}

function productsCount(){
  console.log('<Products Count>');
  console.log('Starting Qty', $('body .cart-bundle').attr('data-qty'));
  console.log('Starting Price', $('body .cart-bundle').attr('data-price'));
  // var totalQty = parseInt($('.cart-bundle').attr('data-qty'),10);
  // var totalPrice = parseFloat($('.cart-bundle').attr('data-price'),10) / 100;
  var totalQty = 0;
  var totalPrice = 0;
  var thisPrice = 0;
  var subTotal = 0;
  $('.selected .qtyCount').each(function () {
    console.log(this);
    thisPrice = $(this).closest('.ProductItem').data('bundle-price');  
    totalQty += $(this).data('count');
    subTotal += ($(this).data('count') * thisPrice);
  });
  totalPrice += subTotal;
  updateProductCount(totalQty);
  updateProductsPrice(totalPrice);
  var totalQty = 0;
  var totalPrice = 0;
  console.log('</Products Count End>')
}

function selectProduct(product){
  product.addClass('selected');
}

function unSelectProduct(product){
  product.removeClass('selected');
}

function enabledBundleButton(){
  $('.addToBundle').removeClass('disabled');
  $('.addToBundle').addClass('enabled');
  $('body').addClass('bundleable');
}

function disabledBundleButton(){
  $('.addToBundle').removeClass('enabled');
  $('.addToBundle').addClass('disabled');
  $('body').removeClass('bundleable');
}

function updateProductCount(count){
  var pretty_count = count == 0 ? 'no' : count;
  var difference = 3 - count;
  if(difference > 0) {
    $('p.product-count').text('You have ' + pretty_count + ' selected products. Add ' + difference + ' or more products to complete your bundle.');
    disabledBundleButton();
  } else { 
    $('p.product-count').text('You have selected ' + count + ' products. Add your customised bundle to your cart.');
    enabledBundleButton();
  }
  $('p.product-count').attr('product-count', count);
}

function getCartContents(){
  console.log('Cart Contents');
  var bundle_items = [];
  var bundle_price = [];
  $.getJSON('/cart.js', function(cart) {
    $.map(cart.items, function(line_item, index) {
      console.log('Prop',line_item);
      if(line_item.properties["Bundle"] == 'Custom'){
        $('#add_or_update').text('UPDATE BUNDLE');
        bundle_items.push(line_item.quantity);
        bundle_price.push(line_item.line_price);
        console.log('Litem',line_item);
        var product = $('.ProductItem[data-variant="' + line_item.variant_id + '"]');
        product.attr('data-lid',line_item.variant_id);
        product.attr('data-lindex',index + 1);
        product.attr('data-qty', parseInt(line_item.quantity));
        loadProductButton(product, parseInt(line_item.quantity));
        selectProduct(product);

      }
    });
    var sum_price = bundle_price.reduce(function(a, b){
      return a + b;
    }, 0);
    var sum_qty = bundle_items.reduce(function(a, b){
      return a + b;
    }, 0);
    $('.cart-bundle').attr('data-qty',sum_qty);
    $('.cart-bundle').attr('data-price',sum_price);
    productsCount();
  });
}

function loadBundleButton(){ 
  $('p.product-count').after('<br/><span href="#" class="border-button black solid addToBundle "><span id=\"add_or_update\">ADD BUNDLE</span> <span class=\"savings\">$0</span><svg class="Icon Icon--select-arrow-right" role="presentation" viewBox="0 0 21 21"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></span>');
  clickAddBundle();
}

function addBundleToCart(qty){ 
  if(qty >= 3 || qty == 0){
    $('.qtyCount').each(function() {
      var qty = $(this).data('count');
      var vid = $(this).data('variant');
      var lindex = $(this).data('lindex');
      if(lindex != 'undefined'){
        if(qty >= 1){
          // console.log('Updating Item' + lindex);
          CartJS.updateItem(lindex, qty);
        } else {
          // console.log('Removing Item' + lindex);
          CartJS.removeItem(lindex);
        }
      } else { 
        if (qty >= 1){
          console.log('Adding New Item');
          CartJS.addItem(vid, qty, {
            'Bundle': 'Custom'
          });
        }
      }
    });
    redirectingBundle();
    $(document).on('cart.requestComplete', function(event, cart) {
      window.location.href = '/cart';
    }); 
  } else { 
    console.log('Cannot add bundle.');
  }
};

function disableAddBundle(){
  $('.addToBundle').text('Processing bundle...');
}

function redirectingBundle(){
  $('.addToBundle').text('Cart Updating...');
}

function clickAddBundle(){
  $('span.addToBundle').unbind("click").on('click', function(e){
    e.preventDefault();
    var qty = $('p.product-count').attr('product-count');
    if(qty >= 3 || qty == 0){
      addBundleToCart(qty);
      disableAddBundle();
    } else { 
      addBundleToCart(qty);
      // disableAddBundle();
      alert('You can only update your cart bundle to 3 or more products.');
    }
    
  });
  
}

function updateProductsPrice(price){
  $('.savings').text('$' +  Math.round((price + Number.EPSILON) * 100) / 100)
}

$( document ).ready(function() {
  console.log('INITIALIZING BUNDLE BUILDER');
  initPage();
  console.log('/DONE INITIALIZING');
});